/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function fadeIn(el) {
  el.style.opacity = 0;
  el.style.display = 'block' ;

  var last = +new Date();
  var tick = function() {
    el.style.opacity = +el.style.opacity + (new Date() - last) / 400;
    last = +new Date();

    if (+el.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    }
  };

  tick();
}

function addEventListenerList(list, event, fn) {
    for (var i = 0, len = list.length; i < len; i++) {
        list[i].addEventListener(event, fn, false);
    }
}

function forEach(array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
}

document.addEventListener('variant:changed', function(event) {
	var k = document.querySelector(".ProductMeta__SKU");
    if (k) k.innerHTML = event.detail.variant.sku;
})

function toggleTabs() {
  var targetSelector = this.getAttribute('aria-controls'),
	  currentTab = document.querySelector('.js-tab.is-active'),
      prodInfoHeight
    
  currentTab.classList.remove('is-active')
  currentTab.setAttribute('aria-selected', false)
  document.getElementById(currentTab.getAttribute('aria-controls')).setAttribute('aria-hidden', true)
  
  this.classList.add('is-active')
  this.setAttribute('aria-selected', true)
  document.getElementById(targetSelector).setAttribute('aria-hidden', false)
  
  prodInfoHeight = document.querySelector('.Product__Info').offsetHeight
  document.querySelector('.Product__InfoWrapper').style.maxHeight = prodInfoHeight + 'px'
  document.querySelector('.Product__Aside').style.minHeight = prodInfoHeight - document.querySelector('.Product__Gallery').offsetHeight + 'px'
}

document.addEventListener("DOMContentLoaded", function(event) {
  var productTabs = document.querySelectorAll('.js-tab')
  
  if (productTabs.length !== 0) {
    addEventListenerList(productTabs, 'click', toggleTabs)
  }
})

document.addEventListener("DOMContentLoaded", function(event) {
  var customShopNow = document.querySelector('[data-section-id="page-custom-products"] .ProductList--shopNow')

  if (customShopNow) {
    var flkty, flktyConfig
    
    flktyConfig = JSON.parse(customShopNow.getAttribute('data-flickity-config'))
    flkty = new Flickity(customShopNow, flktyConfig)
  }
})

document.addEventListener("DOMContentLoaded", function(event) {      
  var cartPickup = document.getElementById("cart-pickup")
  
  if (cartPickup !== null) {
    $(cartPickup).datepicker({
      minDate: 0,
      maxDate: '+2M',
      beforeShowDay: jQuery.datepicker.noWeekends
    });
  }
});




// Get the header
var header = document.getElementById("shopify-section-header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

window.addEventListener('scroll', function() {
  if (window.innerWidth <= 640 || !document.body.classList.contains('template-index')) return false
  
  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  if (window.pageYOffset > sticky) {
    header.classList.add("is-stuck");
  } 
  else {
    header.classList.remove("is-stuck");
  }
})


//Out of stock reminder form
$('#notify-me').click(function() {
  $('.ProductForm__AddToCart').hide();  
  $('#notify-me-wrapper').fadeIn();
  return false;
} );